// Native Facebook Pixel implementation
declare global {
  interface Window {
    fbq: any
    _fbq?: any
    pixelLoaded?: boolean
  }
}

/**
 * Initialize the Facebook Pixel
 * @param pixelId The Facebook Pixel ID
 */
export const initMetaPixel = (pixelId: string): void => {
  if (typeof window === 'undefined') return

  try {
    // Initialize the Facebook Pixel if it doesn't exist
    if (!window.fbq) {
      window._fbq = window.fbq = function () {
        // @ts-ignore
        window.fbq.callMethod
          ? window.fbq.callMethod.apply(window.fbq, arguments)
          : window.fbq.queue.push(arguments)
      }
      window.fbq.push = window.fbq
      window.fbq.loaded = true
      window.fbq.version = '2.0'
      window.fbq.queue = []

      // Cargar el script de Facebook
      const script = document.createElement('script')
      script.async = true
      script.src = 'https://connect.facebook.net/en_US/fbevents.js'
      document.head.appendChild(script)
      console.log('Meta Pixel script cargado dinámicamente')
    }

    // Initialize the pixel
    window.fbq('init', pixelId)
    console.log(`Meta Pixel inicializado con ID: ${pixelId}`)
  } catch (error) {
    console.error('Error al inicializar Meta Pixel:', error)
  }
}

/**
 * Track a standard event
 * @param event The event name
 * @param params Optional parameters
 */
export const track = (event: string, params?: Record<string, any>): void => {
  if (typeof window === 'undefined') return

  try {
    if (window.fbq) {
      window.fbq('track', event, params)
      console.log(`Evento '${event}' enviado correctamente`, params || '')
    } else {
      console.error(
        `No se pudo enviar el evento '${event}' - fbq no está disponible`,
      )
    }
  } catch (error) {
    console.error(`Error al enviar evento '${event}':`, error)
  }
}

/**
 * Track a custom event
 * @param name The custom event name
 * @param params Optional parameters
 */
export const trackCustom = (
  name: string,
  params?: Record<string, any>,
): void => {
  if (typeof window === 'undefined') return

  try {
    if (window.fbq) {
      window.fbq('trackCustom', name, params)
      console.log(
        `Evento personalizado '${name}' enviado correctamente`,
        params || '',
      )
    } else {
      console.error(
        `No se pudo enviar el evento personalizado '${name}' - fbq no está disponible`,
      )
    }
  } catch (error) {
    console.error(`Error al enviar evento personalizado '${name}':`, error)
  }
}

/**
 * Track a Contact event (WhatsApp clicks)
 * @param params Optional parameters
 */
export const trackContact = (params?: Record<string, any>): void => {
  if (typeof window === 'undefined') return
  track('Contact', params)
}

/**
 * Track when user scrolls to or views the lead form
 * @param params Optional parameters
 */
export const trackFormView = (params?: Record<string, any>): void => {
  if (typeof window === 'undefined') return
  track('ViewContent', {
    content_name: 'Lead Form Viewed',
    content_type: 'form',
    ...params,
  })
}

/**
 * Track a page view
 */
export const pageview = (): void => {
  if (typeof window === 'undefined') return

  try {
    if (window.fbq) {
      window.fbq('track', 'PageView')
      console.log('Evento PageView enviado correctamente')
    } else {
      console.error(
        'No se pudo enviar el evento PageView - fbq no está disponible',
      )
    }
  } catch (error) {
    console.error('Error al enviar evento PageView:', error)
  }
}
